/* eslint-disable import/prefer-default-export */
const studentInfo = {
  careerSupport: {
    numberTeamMembers: '125',
  },
  currentStudents: {
    number: '14,000',
    numberInThousands: '14',
  },
  grads: {
    number: '85,000',
    numberInThousands: '85',
  },
  lastUpdatedDate: 'April 2024',
  learnerServices: {
    numberTeamMembers: '125',
  },
  // Legal confirmed that although we were officially founded in 1993, our true inception as a functioning school started in 1994.
  yearsInBusiness: `${new Date().getFullYear() - 1994}`,
}

export { studentInfo }
